import { useEffect, useState } from "react";
import api from "../lib/api";
import SHOTS from "./guideShots.json";

export function GuideShot({ name, caption }) {
  const marks = SHOTS[name] || [];
  const [url, setUrl] = useState(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    let u;
    api.get(`/guide/shots/${name}.jpg`, { responseType: "blob" })
      .then(({ data }) => { u = URL.createObjectURL(data); setUrl(u); })
      .catch(() => setHidden(true));
    return () => u && URL.revokeObjectURL(u);
  }, [name]);
  if (hidden) return null;
  return (
    <figure className="my-5" data-testid={`guide-shot-${name}`}>
      <div className="relative rounded-lg overflow-hidden border border-brand-border shadow-sm bg-brand-page aspect-[12/5]">
        {url && <a href={url} target="_blank" rel="noreferrer" title="Open full size">
          <img src={url} alt={caption || name} className="w-full h-auto block" />
        </a>}
        {marks.map((m, i) => (
          <div key={i} className="absolute pointer-events-none rounded-md ring-2 ring-brand-gold/90 bg-brand-gold/10"
            style={{ left: `${m.x}%`, top: `${m.y}%`, width: `${m.w}%`, height: `${m.h}%` }}>
            <span className="absolute -top-2.5 -left-2.5 h-6 w-6 rounded-full bg-brand-ink text-brand-page text-[11px] font-semibold flex items-center justify-center shadow ring-2 ring-brand-page">{i + 1}</span>
          </div>
        ))}
      </div>
      <figcaption className="mt-3 space-y-1.5">
        {caption && <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">{caption}</p>}
        <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5">
          {marks.map((m, i) => (
            <li key={i} className="flex items-start gap-2 text-[13px] text-brand-muted" data-testid={`guide-shot-${name}-mark-${i + 1}`}>
              <span className="shrink-0 h-5 w-5 rounded-full bg-brand-ink text-brand-page text-[10px] font-semibold flex items-center justify-center mt-px">{i + 1}</span>
              {m.label}
            </li>
          ))}
        </ol>
      </figcaption>
    </figure>
  );
}
